import React, { useContext, useState } from "react";

import { InventoriesTableContext } from "./inventories_table";
import PropTypes from "prop-types";
import InventoryQuantity from "./inventory_quantity";
import ReadMore from "../resuable/read_more";
const columns = ["Name", "Category", "Quantity", "Description", "Updated At"];

function InventoryTableComponent() {
  const { data } = useContext(InventoriesTableContext);

  const [sortingColumn, setSortingColumn] = useState(getUrlParams("sort_by", "created_at"));
  const [sortOrder, setSortOrder] = useState(getUrlParams("sort_order", "desc")); // "asc" or "desc"

  const toggleSortOrder = (currentOrder) => (currentOrder === "asc" ? "desc" : "asc");

  const handleHeaderClick = (column) => {
    const columnInSnakeCase = snakeCase(column);
    const newSortOrder = sortingColumn === columnInSnakeCase ? toggleSortOrder(sortOrder) : "asc";
    setSortingColumn(columnInSnakeCase);
    setSortOrder(newSortOrder);

    updateUrlParams({ sort_by: columnInSnakeCase, sort_order: newSortOrder });
  };
  return (
    <table className="table is-striped is-fullwidth ccw-table inventory-table">
      <caption className="ccw-visually-hidden">Inventory records</caption>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              scope="col"
              aria-sort={
                sortingColumn === snakeCase(column)
                  ? sortOrder === "asc"
                    ? "ascending"
                    : "descending"
                  : "none"
              }
            >
              <button
                type="button"
                className="column-cell inventory-sort-button"
                onClick={() => handleHeaderClick(column)}
              >
                {column}
                <span
                  className="inventory-sort-button__direction"
                  aria-hidden="true"
                  style={{ display: sortingColumn === snakeCase(column) ? "unset" : "none" }}
                >
                  {sortOrder === "desc" ? "↓" : "↑"}
                </span>
              </button>
            </th>
          ))}
          <th scope="col" colSpan={3}>
            <span className="ccw-visually-hidden">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.id}>
            {Object.keys(row).map((rowKey, r_index) => {
              if (rowKey === "id") return null;

              return (
                <td
                  key={`${rowKey} ${r_index}`}
                  className={`inventory-table__cell--${rowKey}`}
                  data-label={rowLabel(rowKey)}
                >
                  <RowComponent rowKey={rowKey} value={row[rowKey]} />
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const RowComponent = ({ rowKey, value }) => {
  if (isActionColumn(rowKey) && !value) return null;
  if (value === null || value === undefined) return <span aria-label="Not provided">—</span>;

  switch (rowKey) {
    case "quantity":
      return <InventoryQuantity quantity={parseInt(value)} />;
    case "description":
      return <ReadMore text={value} />;
    default:
      return _isHtmlTag(value) ? (
        <div dangerouslySetInnerHTML={{ __html: value }} />
      ) : (
        <span>{value}</span>
      );
  }
};

RowComponent.propTypes = {
  rowKey: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

RowComponent.displayName = "RowComponent";

function _isHtmlTag(str) {
  const regex = /^<([a-z]+)([^<]+)*(?:>(.*)<\/\1>|\s+\/>)$/;
  return typeof str === "string" && regex.test(str);
}

function snakeCase(str) {
  return str.toLowerCase().replace(/ /g, "_");
}

function isActionColumn(rowKey) {
  return rowKey === "add_remove_stock" || rowKey.endsWith("_link");
}

function rowLabel(rowKey) {
  const labels = {
    name: "Name",
    category: "Category",
    quantity: "Quantity",
    description: "Description",
    updated_at: "Updated at",
    add_remove_stock: "Stock",
    recover_link: "Recover",
    edit_link: "Edit",
    activity_link: "Activity"
  };

  return labels[rowKey] || rowKey;
}

function getUrlParams(param, defaultValue) {
  return new URLSearchParams(window.location.search).get(param) || defaultValue;
}

function updateUrlParams(params) {
  const currentUrl = new URL(window.location);
  Object.entries(params).forEach(([key, value]) => {
    currentUrl.searchParams.set(key, value);
  });
  window.location.href = currentUrl.href;
}
export default InventoryTableComponent;
